module.exports = __webpack_public_path__ + "img/8.643621a0.svg";